import { z } from "zod"

const outOfUsageErrorSchema = z.object({
    status: z.literal("outOfSpace"),
    flightId: z.string(),
    size: z.number(),
})

const unauthorizedErrorSchema = z.object({
    status: z.literal("unauthorized"),
})

const unknownErrorSchema = z.object({
    status: z.literal("unknown"),
})

const timeoutErrorSchema = z.object({
    status: z.literal("timeout"),
})

const successSchema = z.object({
    status: z.literal("success"),
})

export const ingestResponseSchema = z.discriminatedUnion("status", [
    outOfUsageErrorSchema,
    unauthorizedErrorSchema,
    unknownErrorSchema,
    timeoutErrorSchema,
    successSchema,
])

export type IngestResponse = z.infer<typeof ingestResponseSchema>
